import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fc6504f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "leaderboard-list"
}
const _hoisted_2 = { class: "index_col" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "bold points-col" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "title" }

import { computed, ref, onMounted, onUnmounted, watch } from 'vue';
import { getLeaderboard } from '@/services/leaderboardService';
import { useUserStore } from '@/stores/userStore';
import EndLayoutComponent from '@/components/EndLayoutComponent.vue';
import EndHeader from '@/features/EndHeader.vue';
import { isPhone } from '@/utils/responsiveHelper';

import {
  getRandomDesciption,
  getPlacement,
  convertToSuffix
} from '@/utils/tableHelper';
import TrophyCol from '@/features/TrophyCol.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LeaderBoard',
  async setup(__props) {

let __temp: any, __restore: any

const userStore = useUserStore();

const currentPage = ref(1);
const windowHeight = ref(window.innerHeight);
const tableContainer = ref(null);
const placement = ref([]);

const calculatePlacement = () => {
  placement.value = currentLeaderboardPage.value.map((entry, index) => {
    return getPlacement(currentPage.value, entriesPerPage.value, index);
  });
};

const entriesPerPage = computed(() => {
  const heightPerItem = isPhone() ? 72 : 61.25;

  const availableHeight = tableContainer.value?.clientHeight || 500;

  return Math.max(1, Math.floor(availableHeight / heightPerItem) - 1);
});

// Function to update window width
const onResize = () => {
  windowHeight.value = window.innerHeight;
};

onMounted(() => {
  window.addEventListener('resize', onResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', onResize);
});

const leaderboard = (
  ([__temp,__restore] = _withAsyncContext(() => getLeaderboard())),
  __temp = await __temp,
  __restore(),
  __temp
);
const nameDescription = getRandomDesciption();
const leaderboardData = ref(leaderboard.data);
const currentUserPosition =
  leaderboard.data?.findIndex((element) => element[0] === userStore.id) + 1;
const totalPages = computed(() =>
  Math.ceil(leaderboard.data.length / entriesPerPage.value)
);

const currentLeaderboardPage = computed(() => {
  const start = (currentPage.value - 1) * entriesPerPage.value;
  const end = start + entriesPerPage.value;
  return leaderboardData.value.slice(start, end);
});

watch(
  () => currentPage.value,
  () => {
    calculatePlacement();
  }
);

onMounted(() => {
  calculatePlacement();
});

return (_ctx: any,_cache: any) => {
  const _component_timeago = _resolveComponent("timeago")!

  return (_openBlock(), _createBlock(EndLayoutComponent, null, {
    default: _withCtx(() => [
      _createVNode(EndHeader, {
        title: "Hall of Fame",
        class: "header"
      }),
      _createElementVNode("div", {
        class: "leaderboard-container",
        ref_key: "tableContainer",
        ref: tableContainer
      }, [
        (_unref(leaderboard).errorOccurred === false)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentLeaderboardPage.value, (entry, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: _normalizeClass({
            'leaderboard-entry': true,
            winner: currentPage.value === 1 && index === 0,
            'top-three': placement.value[index] !== 1 && placement.value[index] <= 3,
            'current-user': currentUserPosition === placement.value[index]
          })
                }, [
                  _createElementVNode("span", _hoisted_2, [
                    _createElementVNode("span", {
                      class: _normalizeClass({
                index: true,
                winner: placement.value[index] === 1,
                'top-three': placement.value[index] !== 1 && placement.value[index] <= 3
              })
                    }, _toDisplayString(placement.value[index]) + ".", 3)
                  ]),
                  _createVNode(TrophyCol, {
                    class: "trophy-col",
                    placement: placement.value[index]
                  }, null, 8, ["placement"]),
                  _createElementVNode("span", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(entry[1]), 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(nameDescription)[placement.value[index] - 1]), 1)
                  ]),
                  _createVNode(_component_timeago, {
                    class: "date",
                    datetime: new Date(entry[4] + ' UTC')
                  }, null, 8, ["datetime"]),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(convertToSuffix)(entry[3])), 1)
                ], 2))
              }), 128)),
              (!_unref(isPhone)())
                ? (_openBlock(), _createBlock(PaginationComponent, {
                    key: 0,
                    currentPage: currentPage.value,
                    totalPages: totalPages.value,
                    onNext: () => (currentPage.value = Math.min(totalPages.value, currentPage.value + 1)),
                    onBack: () => (currentPage.value = Math.max(1, currentPage.value - 1))
                  }, null, 8, ["currentPage", "totalPages", "onNext", "onBack"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(leaderboard).errorMessage), 1)
            ])),
        (_unref(isPhone)() & (_unref(leaderboard).errorOccurred === false))
          ? (_openBlock(), _createBlock(PaginationComponent, {
              key: 2,
              currentPage: currentPage.value,
              totalPages: totalPages.value,
              onNext: () => (currentPage.value = Math.min(totalPages.value, currentPage.value + 1)),
              onBack: () => (currentPage.value = Math.max(1, currentPage.value - 1))
            }, null, 8, ["currentPage", "totalPages", "onNext", "onBack"]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _: 1
  }))
}
}

})